// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageAudioPlayer__container-eb40d0 {
  box-sizing: border-box;
  display: flex;
  width: 100vw;
  max-width: 100%;
}

.MessageAudioPlayer__icon-aedce8 {
  cursor: pointer;
  margin-inline-end: 8px;
}

.MessageAudioPlayer__info-b7f8cc {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.MessageAudioPlayer__title-b69ca4 {
  color: var(--base-110);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/components/AudioPlayer/MessageAudioPlayer/MessageAudioPlayer.styles.m.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,sBAAA;EACA,wBAAA;EACA,0CAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  width: 100vw;\n  max-width: 100%;\n}\n\n.icon {\n  cursor: pointer;\n  margin-inline-end: 8px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.title {\n  color: var(--base-110);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessageAudioPlayer__container-eb40d0`,
	"icon": `MessageAudioPlayer__icon-aedce8`,
	"info": `MessageAudioPlayer__info-b7f8cc`,
	"title": `MessageAudioPlayer__title-b69ca4`
};
module.exports = ___CSS_LOADER_EXPORT___;
